import { render, staticRenderFns } from "./_base-author-questions.vue?vue&type=template&id=9b6cf298"
import script from "./_base-author-questions.vue?vue&type=script&lang=js"
export * from "./_base-author-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports